import React from 'react';
import { serverHelpers } from '@pik/pik-utils';

import FraudPrevention from '../components/FraudPrevention';

import { wrapper } from '../services/store';
import FRAUD_PREVENTION_DATA from '../common/constants/fraudPrevention';

const Page = ({ pageData }) => (
  <div>
    <FraudPrevention {...pageData} />
  </div>
);

export const getServerSideProps = wrapper.getServerSideProps(async (ctx) => {
  try {
    const { appService: { lang } } = ctx.store.getState();

    return {
      props: {
        pageData: {
          lang,
          ...FRAUD_PREVENTION_DATA,
        },
      },
    };
  } catch (error) {
    const errorObject = serverHelpers.errorFormatter(error, ctx);
    console.error(errorObject);
    ctx.res.statusCode = errorObject.statusCode;

    return {
      props: {
        error: errorObject,
      },
    };
  }
});

export default Page;
